import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'lg-testimonial-grid',
  styleUrl: 'lg-testimonial-grid.scss',
  shadow: false,
})
export class LgTestimonialGrid {
  elGrid: HTMLElement;
  testimonials: NodeListOf<Element>;
  private columns: number = 3;

  componentDidLoad() {
    this.testimonials = this.elGrid.querySelectorAll('.Testimonial__card');

    this.testimonials.forEach((testimonial, index) => {
      if (!testimonial.classList.contains('Testimonial__card')) return;

      testimonial.addEventListener('click', (event) => {
        event.preventDefault();
        this.elGrid.querySelectorAll('.ajaxContainer').forEach((container) => {
          container.classList.remove('open');
          container.remove()
        });
        if (testimonial.classList.toggle('active')) {
          this.testimonials.forEach(t => t !== testimonial && t.classList.remove('active'));
          this.columns = window.innerWidth > 992 ? 6 : 3;
          const url = (testimonial as HTMLAnchorElement).href;
          const containerDiv = document.createElement('div');
          containerDiv.classList.add('ajaxContainer', 'col-12');
          const rowIndex = Math.floor(index / this.columns);
          const lastElementInRowIndex = (rowIndex + 1) * this.columns - 1;
          if (lastElementInRowIndex < this.testimonials.length) {
            this.testimonials[lastElementInRowIndex].after(containerDiv);
          } else {
            this.elGrid.appendChild(containerDiv);
          }
          this.loadAjax(url, containerDiv);
          testimonial.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    if (id) {
      this.testimonials.forEach(testimonial => {
        if (testimonial.id === id) {
            testimonial.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
        }
      })
    }
  }

  async loadAjax(url: string, container: Element) {
    const ajaxUrl = url + '?ajax=true';
    const loadingDiv = document.createElement('div');
    loadingDiv.classList.add('loading', 'col-12', 'd-flex', 'justify-content-center', 'align-items-center');
    loadingDiv.innerHTML = '<div class="pb-md pb-md-lg"><lg-icon name="loader" class="d-flex animate rotate"></lg-icon></div>';
    container.after(loadingDiv);

    try {
      const response = await fetch(ajaxUrl);
      const data = await response.text();
      container && (
        container.innerHTML = data,
        (container as HTMLElement).style.setProperty('--openHeight', 'auto'),
        container.classList.add('open')
      );
    } catch (error) {
      console.error(error);
    } finally {
      loadingDiv.remove();
    }
  }

  render() {
    return (
      <Host>
        <div class="row" ref={el => (this.elGrid = el)}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
